<template>
  <div>
    <div class="card">
      <p class="detail">
        <strong>{{ $t("user.mine.address") }}: </strong> {{ wallets.address }}
      </p>
      <p class="detail">
        <strong>{{ $t("user.mine.balance") }}: </strong>
        <span class="val">{{ balance.available || 0 }} </span
        ><strong> MASS</strong>
         &nbsp; &nbsp; &nbsp; <span class="grey" v-if="balance.all != balance.available"> <strong>{{ $t("user.mine.balance_frozen") }}:</strong> {{ balance.all  - balance.available }} <strong > MASS</strong></span>
      </p>
      <p class="detail">
        <strong>{{ $t("user.mine.activationQuota") }}: </strong>
        <span class="val">{{ balance.binding || 0 }} </span
        ><strong> MASS</strong>
      </p>
    </div>
    <div class="row">
      <div class="col-6 mr-1">
        <div class="card">
          <div class="card-tltle">
            <img src="@/assets/image/book.png" />
            {{ $t("home.components.activation.activation") }}
          </div>
          <div class="card-body">
            <div class="form-group">
              <span class="form-label"
                >{{ $t("home.components.activation.outAddress") }}:</span
              >
              <input disabled :value="wallets.address" class="form-input" />
            </div>
            <div class="form-group">
              <span class="form-label"
                >{{ $t("home.components.activation.changeFile") }}:</span
              >
              <span
                class="value-ud"
                @click="
                  type = '';
                  blurFile();
                "
              >
                {{
                  file ? file.name : $t("home.components.activation.changeFile")
                }}</span
              >
            </div>
            <div class="form-group">
              <span class="form-label">&nbsp;</span>
              <button class="btn  btn-blue-sm" @click="send">
                {{ $t("home.components.activation.send") }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="col-6 ml-1">
        <div class="card query-card">
          <div class="card-tltle">
            <img src="@/assets/image/book.png" />
            {{ $t("home.components.activation.query") }}
          </div>
          <div class="card-body">
            <span class="value-ud" @click="query" v-loading="queryLoading">
              {{ $t("home.components.activation.chooseQueryFile") }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col card">
        <div class="card-tltle">
          <img src="@/assets/image/book.png" />
          {{ $t("home.components.activation.record") }}
        </div>
        <div class="card-body">
          <table cellspacing="0">
            <thead>
              <tr>
                <th>
                  {{ $t("home.components.activation.hash") }}
                </th>
                <th>
                  {{ $t("home.components.activation.height") }}
                </th>
                <th>
                  {{ $t("home.components.activation.outAddress") }}
                </th>

                <th>
                  {{ $t("home.components.activation.fileId") }}
                </th>
                <th>
                  {{ $t("home.components.activation.amount") }}
                </th>
                <th style="text-align: center;">
                  {{ $t("home.components.activation.count") }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in transaction.results" :key="item.id">
                <td :title="item.tx_id">{{ item.tx_id | textcut(5) }}</td>
                <td>{{ item.block_height > 0 ? item.block_height : $t("home.components.activation.offChain") }}</td>
                <td :title="item.other_address">
                  {{ item.other_address | textcut(5) }}
                </td>
                <td>
                  <template v-if="!item.show">
                    {{
                      item.binding_targets ? item.binding_targets[0].target : ""
                    }}
                  </template>
                  <template v-else>
                    <div
                      class="target_item"
                      v-for="(t, i) in item.binding_targets"
                      :key="t.amount + '_target_' + i"
                    >
                      {{ t.target  }}
                    </div>
                  </template>
                </td>
                <td>
                  <span
                      v-if="(item.binding_targets || []).length > 1"
                      class="show-icon"
                      :class="{up:item.show}"
                      @click="$set(item, 'show', !item.show)"
                    >
                      <img width="15" height="15" src="@/assets/image/arrow.png"
                    /></span>
                  <template v-if="!item.show">
                    {{ item | totalAmount }}
                    
                  </template>
                  <template v-else>
                    <div
                       class="target_item"
                      v-for="(t, i) in item.binding_targets"
                      :key="t.amount + '_amount_' + i"
                    >
                      {{ t.amount }}
                      
                    </div>
                  </template>
                </td>
                <td style="text-align: center;">
                  {{ (item.binding_targets || []).length }}
                </td>
              </tr>
            </tbody>
          </table>
          <Pagination
            class="pagin"
            :currentPage="currentPage"
            :totalPages="pages"
            @goto="goto"
          />
        </div>
      </div>
    </div>
    <input
      hidden
      accept="application/json"
      @change="changeFile"
      ref="file"
      type="file"
    />

    <QueryRes
      :show.sync="showQueryRes"
      :list="queryResList"
      :fileName="queryFileName"
    />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { Pagination, Password } from "@/components";
import QueryRes from "./components/QueryRes.vue";
export default {
  name: "activation",
  meta: {
    authorization: true,
  },
  data() {
    return {
      showSuccess: false,
      queryLoading: false,
      currentPage: 1,
      limit: 10,
      outAddress: "",
      file: "",
      type: "",
      sendData: {},
      showQueryRes: false,
      queryFileName: "",
      queryResList: [],
    };
  },
  components: {
    Pagination,
    QueryRes,
  },
  computed: {
    ...mapState("wallet", ["transaction", "balance", "wallets"]),
    pages() {
      return this.transaction.page_count;
    },
  },
  filters: {
    totalAmount(item) {
      if (Array.isArray(item.binding_targets)) {
        return item.binding_targets.reduce((t, c) => {
          return t + Number(c.amount);
        }, 0).toFixed(7);
      }
      return 0;
    },
  },
  methods: {
    ...mapActions("wallet", [
      "getWallets",
      "getBalance",
      "getTransaction",
      "sendActivation",
      "queryActivation",
      "refrushWallet",
    ]),
    ...mapActions("user", ["walletLogin"]),
    goto(page) {
      this.currentPage = page;
      this.getTransaction({ page: page, size: this.limit, type: "binding" });
    },
    blurFile() {
      this.$refs.file.click();
    },
    readJsonFile(file) {
      return new Promise((re, je) => {
        let reader = new FileReader();
        reader.readAsText(file, "UTF-8");
        reader.onload = (e) => {
          let fileContent = e.target.result;
          try {
            const json = JSON.parse(fileContent);
            if (!json.plots) {
              this.$tooltip.warning(
                this.$t("home.components.activation.noPlots")
              );
              je();
              return;
            }
            if (!Array.isArray(json.plots)) {
              this.$tooltip.warning(
                this.$t("home.components.activation.plotsError")
              );
              je();
              return;
            }
            const errorPlot = json.plots.find((e) => {
              const keys = Object.keys(e);
              return !(
                keys.includes("target") &&
                keys.includes("type") &&
                keys.includes("size")
              );
            });
            if (errorPlot) {
              this.$tooltip.warning(
                this.$t("home.components.activation.PlotRrror")
              );
              je();
              return;
            }
            re(json);
          } catch (e) {
            this.$tooltip.warning(
              this.$t("home.components.activation.fileError")
            );
            je();
          }
          this.$refs.file.value = "";
        };
      });
    },
    changeFile() {
      const file = this.$refs.file.files[0];
      if (!file) return;
      if (this.type == "query") {
        this.queryFileName = file.name;
        this.queryLoading = true;
        this.readJsonFile(file)
          .then(async (data) => {
            const res = await this.queryActivation(data);
            this.showQueryRes = true;
            this.queryLoading = false;
            this.queryResList = res || [];
          })
          .catch(() => {
            this.queryLoading = false;
          });
      } else {
        this.file = file;
      }
    },
    async confirmSend(pwd) {
      try {
        this.sendData.passphrase = pwd;
        await this.sendActivation(this.sendData);
        this.$tooltip.success(this.$t("home.success"));
        this.refrushWallet();
        this.getTransaction({ page: 1, size: this.limit, type: "binding" });
        this.$modal.close();
      } catch (e) {
        console.log(e);
      }
    },
    send() {
      this.readJsonFile(this.file).then((data) => {
        this.sendData = data;
        this.$modal.show({
          component: <Password vOn:submit={this.confirmSend} />,
          close: () => {},
        });
      });
    },
    query() {
      this.type = "query";
      this.blurFile();
    },
  },
  async mounted() {

    this.$store.commit('wallet/SET_TRANSACTION',[])
    try {
      await this.getWallets();
    } catch (e) {
      this.$router.push({ name: "createWallet" });
    }
    
    this.getBalance();
    this.getTransaction({
      page: this.currentPage,
      size: this.limit,
      type: "binding",
    });
  },
};
</script>
<style lang="scss" scoped>
.pagin {
  justify-content: flex-end;
}

.query-card {
  height: 100%;
  display: flex;
  flex-direction: column;
  .card-body {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
  }
}
.row {
  margin-top: 30px;
  display: flex;
}
.col {
  flex: 1;
}
.col-6 {
  flex: 0.5;
}
.ml-1 {
  margin-left: 15px;
}
.mr-1 {
  margin-right: 15px;
}
.detail {
  font-size: 14px;
  color: #080807;
  line-height: 14px;
  margin: 20px 0;
  .val {
    font-size: 14px;
    font-weight: 400;
    color: var(--main-color);
    line-height: 14px;
  }
}

.form-group {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  .form-label {
    width: 70px;
    font-size: 14px;
    font-weight: 400;
    color: #656161;
    line-height: 14px;
    flex-shrink: 0;
  }
  .form-input,
  .form-input:focus-visible {
    background: #ffffff;
    border-radius: 2px;
    padding: 8px 10px;
    border: 1px solid #e73419;
    font-size: 12px;
    font-weight: 400;
    color: #060606;
    line-height: 17px;
  }
}
.value-ud {
  font-size: 12px;
  font-weight: bold;
  color: #e73419;
  line-height: 12px;
  text-decoration: underline;
  cursor: pointer;
}
.show-icon {
  cursor: pointer;
  position: absolute;
  right: 25px;
  top: 22px;
  transform: rotate(0deg);
  translate: 500ms transform;
  &.up{
    transform: rotate(-180deg);
  
  }
  img { 
    vertical-align: text-top;
  }
}
.target_item:not(:last-child){
    margin-bottom: 10px;
}
table {
  tbody {
    tr {
      border-bottom: 1px solid #ddd;
    }
  }
}
</style>
